import React from 'react';
import { Redirect, Switch } from 'react-router-dom';
import { Route } from 'react-router';
import { Grid, StylesProvider, ThemeProvider } from '@material-ui/core';
import theme from '@prime/theme';
import '@fortawesome/fontawesome-free/css/fontawesome.css';
import '@fortawesome/fontawesome-free/css/regular.css';
import '@fortawesome/fontawesome-free/css/solid.css';
import 'devextreme/dist/css/dx.material.blue.light.css';
import '@prime/theme/lib/styles/index.css';
import '@prime/core/lib/styles/index.css';
import CategoryRoute from './features/category/router/CategoryRoute';
import ArticleRoute from './features/article/router/ArticleRoute';
import Dashboard from './features/Dashboard';
import { ROUTES } from './core/router/routes';
import AppBar from './components/AppBar';
import Menu from './components/Menu';
import Container from './components/Container';
import KeywordRoute from './features/keyword/router/KeywordRoute';
import SnackbarProvider from './components/Snackbar/provider/SnackbarProvider';
import MainProgressProvider from './components/progress/MainProgress/provider/MainProgressProvider';
import DataGridProgressProvider from './components/progress/DataGridProgress/provider/DataGridProgressProvider';
import MultimediaRoute from './features/multimedia/router/MultimediaRoute';
import './App.scss';
import UsersRoute from './features/users/router/usersRoute/UsersRoute';

const App: React.FC = () => {
  return (
    <StylesProvider injectFirst>
      <ThemeProvider theme={theme}>
        <SnackbarProvider>
          <Grid container className="Grid-root" spacing={0}>
            <Grid item className="Grid-appBar">
              <AppBar />
            </Grid>
            <Grid item className="Grid-menu">
              <Menu />
            </Grid>
            <Grid item className="Grid-container">
              <MainProgressProvider>
                <DataGridProgressProvider>
                  <Container>
                    <Switch>
                      <Route exact path={ROUTES.DEFAULT} render={() => <Redirect to={ROUTES.DASHBOARD} />} />
                      <Route path={ROUTES.DASHBOARD} component={Dashboard} />
                      {CategoryRoute()}
                      {ArticleRoute()}
                      {KeywordRoute()}
                      {MultimediaRoute()}
                      {UsersRoute()}
                      <Route render={() => <Redirect to={ROUTES.ERROR_404} />} />
                    </Switch>
                  </Container>
                </DataGridProgressProvider>
              </MainProgressProvider>
            </Grid>
          </Grid>
        </SnackbarProvider>
      </ThemeProvider>
    </StylesProvider>
  );
};

export default App;
